<span matTooltipPosition="above" matTooltip="{{('CHECK_REVENUES.OVERVIEW.TABLE.TITLES.DATA_QUALITY' |translate) +
                                       ': ' + percentPipe.transform(((value / getProductionGridQualityDesiredValue() > 1) ? 1 : (value / getProductionGridQualityDesiredValue())), '0.0-2') +
                                       ' (' + value + '/' +  getProductionGridQualityDesiredValue() +
                                       ' ' + ('CHECK_REVENUES.OVERVIEW.TABLE.TITLES.DATA_SETS' |translate) + ')'}}">
  @if (value !== null) {
<img [alt]="'IMAGE_DESCRIPTION.CHECK_REVENUES' | translate" src='{{ "/assets/check-revenues/" + (value >= getProductionGridQualityDesiredValue() ?
                        "icon-yesdata-green" : "icon-nodata-orange") + ".svg" }}'  class="production-grid-image"/>
}
</span>
